import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const projectGenerationRoutes = [
  {
    path: 'generation',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Ad generation')
      },
      permissions: ['READ_GENERATION_SOURCES']
    },
    children: [
      {
        path: '',
        name: 'generation',
        component: wrapLegacyRoute('toolsController', 'generation')
      },
      {
        path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/tools/generationsources/create',
        name: 'generationsourceCreate',
        component: wrapLegacyRoute('generationController', 'create')
      },
      {
        path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/tools/generationsources/:sourceId(\\d+)',
        name: 'generationsource',
        component: wrapLegacyRoute('generationController', 'generationsource')
      },
      {
        path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/tools/generationsources/:sourceId(\\d+)/segmentation',
        name: 'generationSegmentation',
        component: wrapLegacyRoute('generationController', 'segmentation')
      },
      {
        path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/tools/generationsources/:sourceId(\\d+)/campaignsettings',
        name: 'generationCampaignSettings',
        component: wrapLegacyRoute('generationController', 'campaignsettings')
      },
      {
        path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/tools/generationsources/:sourceId(\\d+)/segmentation/params',
        name: 'generationSegmentationParams',
        component: wrapLegacyRoute('generationController', 'segmentationParams')
      }
    ]
  }
];

export default projectGenerationRoutes;
